document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-qty-change]');
  if (!button) return;
  const input = document.querySelector(button.dataset.target);
  if (!input) return;
  const current = parseInt(input.value || '1', 10);
  input.value = Math.max(1, current + parseInt(button.dataset.qtyChange, 10));
});


document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const root = select.closest('[data-product-root]');
  const json = root && root.querySelector('[data-variants-json]');
  if (!json) return;
  let variants;
  try { variants = JSON.parse(json.textContent); } catch (error) { return; }
  const variant = variants.find(function(item) { return String(item.id) === String(select.value); });
  if (!variant) return;

  // Show all gallery photos tagged with the selected colour and switch the main image.
  const gallery = root.querySelector('[data-product-gallery]');
  const mainImage = gallery && gallery.querySelector('.product-main-image img');
  const featured = variant.featured_image;
  const variantImage = featured && (featured.src || (featured.preview_image && featured.preview_image.src));
  const colorIndex = Number(root.dataset.colorOptionIndex);
  const selectedColor = colorIndex >= 0 && variant.options ? String(variant.options[colorIndex] || '').trim().toLowerCase() : '';
  let visibleColorMatches = 0;
  if (gallery && selectedColor) {
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) {
      const alt = (button.dataset.imageColorText || button.dataset.imageAlt || '').toLowerCase();
      const matches = alt.includes(selectedColor);
      button.hidden = !matches;
      if (matches) visibleColorMatches++;
    });
    // If images are not colour-tagged yet, keep the complete gallery visible rather than hiding every photo.
    if (!visibleColorMatches) {
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) { button.hidden = false; });
    }
  } else if (gallery) {
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) { button.hidden = false; });
  }
  if (mainImage && variantImage) {
    mainImage.src = variantImage;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.alt = featured.alt || mainImage.alt;
    const variantPath = variantImage.split('?')[0];
    let matchedThumbnail = null;
    if (gallery) {
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) {
        const thumbPath = (button.dataset.imageSrc || '').split('?')[0];
        if (thumbPath && (thumbPath === variantPath || thumbPath.endsWith(variantPath.split('/').pop()))) {
          matchedThumbnail = button;
        }
      });
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) {
        const active = button === matchedThumbnail && !button.hidden;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }

  const currency = root.dataset.currency || 'INR';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency });
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  if (price) price.textContent = formatter.format(Number(variant.price) / 100);
  if (compare) {
    if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      compare.textContent = formatter.format(Number(variant.compare_at_price) / 100);
      compare.hidden = false;
    } else { compare.textContent = ''; compare.hidden = true; }
  }
  if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
});
/* Product image gallery */
document.addEventListener('click', function(event) {
  const thumbnail = event.target.closest('[data-gallery-thumbnail]');
  if (!thumbnail) return;
  const gallery = thumbnail.closest('[data-product-gallery]');
  const mainImage = gallery && gallery.querySelector('.product-main-image img');
  if (!mainImage) return;
  const nextSrc = thumbnail.dataset.imageSrc;
  if (nextSrc) {
    mainImage.src = nextSrc;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
  }
  gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(function(button) {
    const active = button === thumbnail;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
});


/* Colour/size swatches: select a matching available variant */
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-option-value]');
  if (!button) return;
  const root = button.closest('[data-product-root]');
  const select = root && root.querySelector('[data-variant-select]');
  const json = root && root.querySelector('[data-variants-json]');
  if (!root || !select || !json) return;
  let variants;
  try { variants = JSON.parse(json.textContent); } catch(e) { return; }
  const index = Number(button.dataset.optionIndex);
  const current = variants.find(v => String(v.id) === String(select.value));
  const values = current ? current.options.slice() : [];
  values[index] = button.dataset.optionValueText;
  let match = variants.find(v => v.options.every((value,i) => String(value) === String(values[i])));
  if (!match || !match.available) match = variants.find(v => v.available && String(v.options[index]) === String(values[index]));
  if (!match) return;
  select.value = String(match.id);
  select.dispatchEvent(new Event('change', {bubbles:true}));
});
document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const root = select.closest('[data-product-root]');
  const json = root && root.querySelector('[data-variants-json]');
  if (!root || !json) return;
  let variants;
  try { variants = JSON.parse(json.textContent); } catch(e) { return; }
  const variant = variants.find(v => String(v.id) === String(select.value));
  if (!variant) return;
  root.querySelectorAll('[data-option-group]').forEach(group => {
    const i = Number(group.dataset.optionIndex);
    group.querySelectorAll('[data-option-value]').forEach(button => {
      const active = button.dataset.optionValueText === String(variant.options[i]);
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const label = group.querySelector('[data-selected-option-label]');
    if (label) label.textContent = variant.options[i] || '';
  });
});
document.addEventListener('click', function(event) {
  const link = event.target.closest('.size-chart-link');
  if (link) {
    const chart = document.querySelector('#size-chart');
    if (chart) { event.preventDefault(); chart.hidden = false; }
  }
  if (event.target.closest('[data-size-chart-close]')) {
    const chart = event.target.closest('#size-chart') || document.querySelector('#size-chart');
    if (chart) chart.hidden = true;
  }
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('#size-chart:not([hidden])').forEach(function(chart) { chart.hidden = true; });
});
